var map = {
	"./bg-benefits.jpg": 713,
	"./bg-video-bar.jpg": 4804,
	"./booking.jpg": 3654,
	"./sdfc.png": 5339,
	"./sdfc.svg": 2491,
	"./title-es.png": 8244,
	"./title.png": 5201,
	"./welcome.jpg": 3735
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;